export default {
  list: null,
  acceptPending: false,
  travelPending: false,
  hasPowra: false,
  hasWorksheet: false,
  activeCall: null,
  currentRiskAssessment: {
    fields: {
      hazards: [],
      controls: []
    }
  },
  completedCallForms: [],
  uploadProgress: undefined,
  networkStatus: undefined,
  axiosRequest: undefined,
  forms: [],
  formData: {},
  selectedFormId: '',
  formSchemas: {}
}
